import React from "react";
import styled from "styled-components";

const Icon: React.FC<{
  src: string;
  width?: string;
  height?: string;
  margin?: string;
  hoverImage?: string;
}> = function Icon({ src, width, height, margin, hoverImage }) {
  return (
    <StyledIcon
      width={width}
      height={height}
      src={src}
      margin={margin}
      hoverImage={hoverImage}
    />
  );
};
export default Icon;
const StyledIcon = styled.div<{
  src: string;
  width?: string;
  height?: string;
  margin?: string;
  hoverImage?: string;
}>`
  background-image: ${({ src }) => {
    return `url("${src}")`;
  }};
  &:hover {
    background-image: ${({ hoverImage, src }) => {
      return hoverImage ? `url("${hoverImage}")` : `url("${src}")`;
    }};
  }
  flex-shrink: 0;
  background-repeat: no-repeat;
  background-size: inherit;
  margin: ${({ margin }) => margin || ""};
  width: ${({ width }) => {
    if (width) return width;
    return "16px";
  }};
  height: ${({ height, width }) => {
    if (height) return height;
    if (width) return width;
    return "16px";
  }};
`;
